import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Main from './pages/main';
// import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
// import 'antd/dist/antd.css';
import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/vi';

dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(customParseFormat);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Main />
  </BrowserRouter>
);

// reportWebVitals();
